"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var aftersaleApi = _interopRequireWildcard(require("@/api/aftersaleApi.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      CONTENT_MAP: [{
        title: '承担比例（%）',
        supplier: 'inputNum',
        customer: 'inputNum',
        platform: 'inputNum',
        saleCost: ''
      }, {
        title: '预计金额',
        supplier: 'showNum',
        customer: 'showNum',
        platform: 'showNum',
        saleCost: 'showNum'
      }],
      detailInfo: {
        saleCost: 80
      },
      submitInfo: {}
    };
  },
  computed: {
    priceInfo: function priceInfo() {
      var _ref = this.submitInfo || {},
        supplier = _ref.supplier,
        customer = _ref.customer,
        platform = _ref.platform;
      return {
        supplierAmt: this._handerAmt(supplier),
        customerAmt: this._handerAmt(customer),
        platformAmt: this._handerAmt(platform)
      };
    }
  },
  mounted: function mounted() {},
  methods: {
    _handerAmt: function _handerAmt(num) {
      var _this$detailInfo, _this$detailInfo2;
      if (!((_this$detailInfo = this.detailInfo) !== null && _this$detailInfo !== void 0 && _this$detailInfo.saleCost) || !num) return 0;
      return Number(Number((_this$detailInfo2 = this.detailInfo) === null || _this$detailInfo2 === void 0 ? void 0 : _this$detailInfo2.saleCost) * Number(num) / 100).toFixed(2);
    },
    submitInput: function submitInput() {
      return _objectSpread({}, this.submitInfo);
    }
  }
};